import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Prospect extends Vue {
    @Prop() readonly item: any;
    mounted() {
        // @ts-ignore
        // this.$refs.wrap.style.width =
        //     // @ts-ignore
        //     "calc(100% - " + this.$refs.prospect.offsetLeft + "px)";
    }
}
// @ts-ignore
export { default as Prospect } from "./index.vue";
